import React, {FunctionComponent, useState} from "react";
import Logo from "@App/public/assets/images/repareo.svg";
import HeaderNavigation from "@App/components/common/HeaderNavigation";
import {AdacPartnerLogo} from "@App/components/Home/ContentElements/PartnerHeaderLogos/AdacPartnerLogo";
import {PartnerConfig} from "@App/types";
import partner from "@App/pages/[partner]";
import {GarageListGarageListHeaderProps} from "@App/components/GarageList/GarageListHeader";
import {MehrmarkencenterLogo} from "@App/components/Home/ContentElements/PartnerHeaderLogos/MerhmarkencenterLogo";


export type GarageProfileHeaderProps = {
    partner: PartnerConfig
};


export const GarageProfileHeader: FunctionComponent<GarageProfileHeaderProps> = (({partner}: GarageProfileHeaderProps) => {
    const [open, setOpen] = useState(false)

    return (
        <header className={"garageProfileHeader col-span-full text-gray-700 bg-white top-0 z-20 lg:max-w-[928px] lx:max-w-screen-lgplus my-0 mx-6 md:mx-12 lg:mx-auto"}>
            <HeaderNavigation>
                <div className={'garageProfileHeader__bottom grid grid-cols-12 items-center py-4 lg:py-3'}>

                    <div className={'repareoIcon col-span-6 flex justify-start flex-1 items-center'}>
                        <a href="https://www.repareo.de" title={'repareo.de Werkstattvergleich und Werkstattportal'} className={`z-20 ${partner.partnerLogoFirst ? 'order-1 hidden xl:flex' : ''}`}>
                            <span className="sr-only">repareo</span>
                            <picture>
                                <img
                                    loading={'lazy'}
                                    src={Logo.src}
                                    width={'136'}
                                    height={'35'}
                                    alt="repareo.de Werkstattvergleich und Werkstattportal"
                                />
                            </picture>
                        </a>
                        <div className={`w-38 ${partner.partnerLogoFirst ? 'pr-10' : 'pl-10 hidden xl:flex'}`}>
                            {partner.partnerLogo == 'adacPartnerLogo' && (
                                <AdacPartnerLogo/>
                            )}
                            {partner.partnerLogo == 'mehrmarkencenterPartnerLogo' && (
                                <MehrmarkencenterLogo/>
                            )}
                        </div>
                    </div>

                    <div className={'telContainer col-span-6 flex justify-end items-center'}>
                        <div className={'mr-8 md:mr-3'}>
                            <a href={'tel:+4989244182010'}
                               className={'decoration-0 no-underline flex justify-end items-center rounded-md bg-blue-50 px-3 py-2 sm:p-0 sm:bg-white sm:text-gray-700 text-base leading-6 font-medium'}>
                                <span className={'fa-kit fa-phone fa-fw text-primary text-regular mr-2 inline-block align-middle'}/>
                                <span className={'hidden sm:block'}>+49 89 244 182 010</span>
                                <span
                                    className={'text-sm leading-4 font-medium text-primary-700 sm:hidden'}>Anrufen</span>
                            </a>
                            <span className={'hidden sm:inline-block text-gray-500 text-sm leading-none font-normal'}>
                                8 - 20 Uhr | Montag - Samstag
                            </span>
                        </div>
                        <a className="nav-toggle-subPage nav-open col-span-1" href="#nav-open">
                            <span className="sr-only">Open menu</span>
                            <i className={`fa-kit fa-bars fa-fw text-gray-900 text-3xl pl-2'}`}/>
                        </a>
                        <a className="nav-toggle-subPage nav-closed col-span-1" href="#nav-closed">
                            <span className="sr-only">Close menu</span>
                            <i className={`fa-kit fa-xmark fa-fw text-gray-900 text-3xl pl-2`}/>
                        </a>

                    </div>
                </div>
            </HeaderNavigation>
        </header>
    )
})
